<template>
  <div class="enquiry_detail">
    <el-col :span="24">
      <client-module
        class="inquiryDetail"
        moduletitle="询盘详情"
        :hideBorder="true"
      >
        <el-row
          type="flex"
          justify="start"
          align="center"
        >
          <el-col
            v-for="item in inquiryDetail"
            :key="item.id"
            :span="8"
            class="basic-infor"
          >
            <ig-icon :name="item.label"></ig-icon>
            <span>{{ item.data }}</span>
          </el-col>
          <div
            v-if="expandContent"
            style="width: 100%"
          >
            <el-divider></el-divider>
            <el-col
              v-for="(item, index) in inquiryData.expandContent"
              :key="index"
              :span="8"
              class="basic-infor"
            >
              <span>{{ item }}</span>
            </el-col>
          </div>
          <el-col
            :span="24"
            class="inquiry-content"
          >
            <div class="inquiry-type">
              <span>线索类型：</span>
              <span>{{ inquiryData.inquiryTypeStr }}</span>
              <span
                class="grabage"
                v-if="inquiryData.isFilter === 1"
              >
                疑似垃圾询盘
              </span>
            </div>
            <div class="message">
              <span>留言入口：</span>
              <a
                :href="inquiryData.msgPageUrl"
                target="_blank"
              >{{
                inquiryData.msgPageUrl || '-'
              }}</a>
            </div>
            <div
              class="inquiry-type"
              v-if="inquiryType == 7"
            >
              <span>表单名称：</span>
              <span class="type-name">{{ inquiryData.tableName || '-' }}</span>
            </div>
            <div
              class="hint"
              v-if="inquiryType == 5"
            >
              <span style="color: red;">*</span>
              <span>
                来自Facebook
                Messenger的询盘，是指在您Facebook主页上进行Messenger留言，并留下有效联系信息的用户，若未留有效信息，则仅作为线索，请在Facebook的信息回复中查看
              </span>
            </div>
          </el-col>
        </el-row>
      </client-module>
    </el-col>
    <el-col
      :span="24"
      class="message-accessory"
      v-if="(inquiryType == 2 || inquiryType == 5) && accessoryStart"
    >
      <client-module
        moduletitle="询盘附件"
        :hideBorder="true"
      >
        <div class="accessory">
          <sky-upload-img
            :value="accessoryList"
            :showFileInfo="true"
            :disabled="true"
          ></sky-upload-img>
        </div>
      </client-module>
    </el-col>
    <el-col
      :span="24"
      class="message-content"
    >
      <!-- 原文 -->
      <client-module
        v-if="inquiryType != 5"
        :showTitle="false"
        :hideBorder="true"
      >
        <el-col
          :span="24"
          class="message"
        >
          <shadow-dom :content="message.content"></shadow-dom>
        </el-col>
      </client-module>

      <!-- 译文 -->
      <client-module
        v-if="inquiryType != 5 && message.zhContent"
        :showTitle="false"
        :hideBorder="true"
      >
        <el-col
          :span="24"
          class="translate"
        >
          <div class="translate-content">
            <shadow-dom :content="message.zhContent"></shadow-dom>
          </div>
        </el-col>
      </client-module>
      <!-- 聊天框 -->
      <client-module
        v-if="inquiryType == 5"
        moduletitle="留言内容"
        :hideBorder="true"
      >
        <el-col
          :span="24"
          class="chatFrame"
        >
          <chat-frame
            v-if="chatData"
            :chatData="chatData"
            class="chat-frame"
          ></chat-frame>
        </el-col>
      </client-module>
    </el-col>
    <el-col class="inquiry-action">
      <el-button
        type="primary"
        size="small"
        plain
        :loading="translateLoading"
        @click="inquiryTranslate"
        v-if="inquiryData.translateFlag"
      >立即翻译</el-button>
    </el-col>
  </div>
</template>

<script>
import shadowDom from '@/components/shadowDom/shadowDom'
import enquiry from '@/backend/services/enquiry/enquiry.js'
import clientModule from '@/components/client/clientModule/clientModule'
import chatFrame from '@/components/client/inquiry/chatFrame.vue'
import { mapGetters } from 'vuex'
import { judgeNullValue } from '@/utils/index.js'
export default {
  data() {
    let that = this
    return {
      accessoryList: [],
      inquiryType: that.$route.query.inquiryType,
      inquiryDetail: [],
      inquiryData: {},
      chatData: {},
      translateLoading: false,
    }
  },
  components: {
    shadowDom,
    clientModule,
    chatFrame,
  },
  computed: {
    ...mapGetters(['fbmessagechat']),
    accessoryStart() {
      return this.accessoryList.length != 0
    },
    message() {
      let inquiryData = this.inquiryData
      let arr = []
      if (inquiryData.inquiryType === 2 && inquiryData.emailContentList) {
        let inquryList = inquiryData.emailContentList
        arr = inquryList.filter((item) => item.type == 1)
        if (arr.length === 0) {
          arr = inquiryData.emailContentList
        }
        return {
          content: arr[0].content,
          zhContent: arr[0].zhContent,
        }
      } else {
        return {
          content: inquiryData.message || '',
          zhContent: inquiryData.translation || '',
        }
      }
    },
    expandContent() {
      let { inquiryType, inquiryData } = this
      return (
        (inquiryType == 7 || inquiryType == 1) &&
        !judgeNullValue(inquiryData.expandContent)
      )
    },
  },
  mounted() {
    this.getinquirydetail()
  },
  methods: {
    async getinquirydetail() {
      let id = this.$route.query.id
      let type = this.$route.query.inquiryType
      let res = await enquiry.getInquiryDetails({
        id,
        type,
      })
      // 邮件询盘
      if (this.inquiryType == 2 && res.data.emailFilepartVOList) {
        let accessory = res.data.emailFilepartVOList
        accessory.forEach((item) => {
          item.url = item.filePath
          item.ossName = item.fileName
        })
        this.accessoryList = accessory
      }
      // FB Message
      if (this.inquiryType == 5 && res.data.fbChatRecordShowVO) {
        let accessory = res.data.fbChatRecordShowVO.accessory || []
        accessory = accessory.map((item, index) => {
          let file = {}
          item.urls.forEach((val, idx) => {
            let fileType = val.slice(val.lastIndexOf('.'))
            file.url = val
            file.fileName = `附件${index + 1}.${idx + 1}${fileType || ''}`
            file.ossName = `附件${index + 1}.${idx + 1}${fileType || ''}`
          })
          return file
        })
        this.accessoryList = accessory
        this.$store.dispatch('setfbmessagechat', res.data.fbChatRecordShowVO)
      }

      this.inquiryData = res.data
      let param = res.data
      this.inquiryDetail = [
        {
          id: 1,
          label: 'mingcheng',
          data: param.name || '-',
        },
        {
          id: 2,
          label: 'dianhua',
          data: param.phone || '-',
        },
        {
          id: 3,
          label: 'youxiang2',
          data: param.email || '-',
        },
        {
          id: 4,
          label: 'gongsi',
          data: param.company || '-',
        },
        {
          id: 5,
          label: 'shijian',
          data: param.submitTimeStr || '-',
        },
        {
          id: 6,
          label: 'ip',
          data: param.ip || '-',
        },
        {
          id: 7,
          label: 'dizhi',
          data: param.region || '-',
        },
      ]
      if (type !== 0 || type !== 1) {
        this.inquiryDetail.splice(3, 1)
      }
    },
    // 询盘翻译
    async inquiryTranslate() {
      try {
        let { tableId, websiteType } = this.inquiryData
        this.translateLoading = true
        await enquiry.inquiryTranslate({
          id: tableId,
          type: websiteType,
        })
        this.getinquirydetail()
        this.translateLoading = false
      } catch (error) {
        this.translateLoading = false
        this.$message.warning('翻译失败，请稍后重试')
      }
    },
  },
  watch: {
    fbmessagechat: {
      handler(val) {
        this.chatData = val
      },
      deep: true,
    },
  },
}
</script>

<style scoped lang="scss">
.enquiry_detail {
  width: 100%;
  height: 900px;
  margin: 0 auto;
  .inquiryDetail {
    width: 100%;
    background-color: #fff;
    box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
    border-radius: 4px;
    margin-bottom: 5px;
    .el-row {
      padding: 15px 32px 0;
      flex-wrap: wrap;
      .basic-infor {
        // 单行溢出
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 8px;
        .iconfont {
          color: #7d7d7d;
          font-size: 18px;
          margin-right: 10px;
        }
      }
      .inquiry-content {
        padding: 30px 0;
        margin-top: 22px;
        border-top: 1px solid #e8e8e8;
        .inquiry-type {
          display: flex;
          align-items: center;
          .iconfont {
            font-size: 26px;
            color: #3da1ff;
          }
          .grabage {
            width: 90px;
            height: 24px;
            line-height: 22px;
            border-radius: 4px;
            border: 1px solid rgba(255, 197, 61, 1);
            color: #ffc53d;
            font-size: 12px;
            text-align: center;
            margin: 0 20px;
          }
        }
        .message {
          margin-top: 16px;
          a {
            color: #5aa0ff;
          }
        }
        .hint {
          font-size: 12px;
          color: #666;
          margin-top: 10px;
        }
      }
    }
  }

  .message-accessory {
    margin-bottom: 5px;
  }
  .message-content,
  .message-accessory {
    width: 100%;
    background-color: #fff;
    box-shadow: 0px 2px 4px 0px rgba(67, 93, 255, 0.05);
    border-radius: 4px;
    font-size: 14px;
    color: #333;
    line-height: 20px;
    padding-bottom: 20px;
    box-sizing: border-box;
    .accessory {
      padding: 0 40px 20px;
      box-sizing: border-box;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
    }
    .message {
      min-height: 130px;
      margin: 15px 0 0;
      padding-bottom: 10px;
      overflow-x: auto;
      padding: 0 40px 30px;
      box-sizing: border-box;
    }
    // 改变滚动条样式
    .message::-webkit-scrollbar {
      height: 6px;
    }
    .message::-webkit-scrollbar-thumb {
      background-color: #c7c7c7;
    }
    .message::-webkit-scrollbar-track {
      background-color: #fff;
    }
    .translate {
      min-height: 100px;
      padding: 30px 40px 10px;
      box-sizing: border-box;
      border-top: 1px solid #e8e8e8;
    }
    .chatFrame {
      padding: 0 40px;
      box-sizing: border-box;
      .chat-frame {
        width: 100%;
        border: 1px solid #d8d8d8;
      }
    }
  }
  .inquiry-action {
    width: 100%;
    height: 54px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 40px;
    background-color: #fff;
  }
}
</style>
